import { render, staticRenderFns } from "./userSave.vue?vue&type=template&id=56ff6f5e"
import script from "./userSave.vue?vue&type=script&lang=js"
export * from "./userSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports